enum MessageType {
  ENABLE_UNSAVED_POPUP = 'ENABLE_UNSAVED_POPUP',
  DISABLE_UNSAVED_POPUP = 'DISABLE_UNSAVED_POPUP',
  REDIRECT_TO_PATH = 'REDIRECT_TO_PATH',
}

type UnsavedPopupProps = {
  popUpTitle?: string;
  popUpContent?: string;
  popUpCancelText?: string;
  popUpConfirmText?: string;
};

type EnableUnsavedPopupMessage = {
  type: MessageType.ENABLE_UNSAVED_POPUP;
  props?: {
    popUpTitle?: string;
    popUpContent?: string;
  };
};

type DisableUnsavedPopupMessage = {
  type: MessageType.DISABLE_UNSAVED_POPUP;
};

type RedirectToPathMessage = {
  type: MessageType.REDIRECT_TO_PATH;
  path: string;
};

type Message =
  | EnableUnsavedPopupMessage
  | DisableUnsavedPopupMessage
  | RedirectToPathMessage;

export const enableUnsavedPopup = (props?: UnsavedPopupProps) => {
  const message: EnableUnsavedPopupMessage = {
    type: MessageType.ENABLE_UNSAVED_POPUP,
    props: props,
  };
  dispatchMessage(message);
};

export const disableUnsavedPopup = () => {
  const message: DisableUnsavedPopupMessage = {
    type: MessageType.DISABLE_UNSAVED_POPUP,
  };
  dispatchMessage(message);
};

export const redirectToPath = (path: string) => {
  const message: RedirectToPathMessage = {
    type: MessageType.REDIRECT_TO_PATH,
    path,
  };
  dispatchMessage(message);
};

export const dispatchMessage = (message: Message) => {
  window.top.postMessage(message, '*');
};
